import { Component } from "@angular/core";
import { RouteConfigLoadEnd, RouteConfigLoadStart, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { EnvoirnmentService } from "../../services/envoirnment.service";
import { environment } from "projects/lib/medcare-core-lib/environments/environment";


@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent {
  title = "demo-app";
  loadBilling = true;
  loadingRouteConfig: boolean;
  currentUrl: string;
  isRouteEnabled: boolean = false;

  constructor(
    private router: Router,
    private translate: TranslateService,
    private snackBar: ToastrService,
    private ngxService: NgxUiLoaderService,
    private env: EnvoirnmentService
  ) {
    translate.addLangs(["en", "fr"]);
    translate.setDefaultLang("en");

    const browserLang: string = translate.getBrowserLang();
    translate.use(browserLang.match(/en|fr/) ? browserLang : "en");
    try {
      this.router.errorHandler = (error: any) => {
        // this.router
        //   .navigate([
        //     "/notfound",
        //     { errorMessage: error.message ? error.message : error }
        //   ])
        //   .catch(error => {
        //     console.log(error);
        //   }); // or redirect to default route
        let errorName: string = error.name;
        let errorMessage: string = error.message;
        let firstRoute
        if (errorMessage.includes("Cannot match any routes") || errorMessage.includes("NG04002")){
          const segments = this.currentUrl.split('/').filter(Boolean); // Filter out empty strings
          firstRoute = segments[0].toLowerCase().replace('-', '');
          this.isRouteEnabled = this.getEnvironmentFlag(firstRoute.replace('-', ''));
          errorName =
            "Page/Module not found. Please make sure this Page/Module is part of your application";
        }
        if(this.isRouteEnabled){
          if(firstRoute == "opd"){
            const fullUrl = `${this.env.medcareUrl}/opd-medcare/#${this.currentUrl}`;
            window.location.href = fullUrl;
          }
          else if(firstRoute == "pharmacy"){
            const fullUrl = `${this.env.medcareUrl}/pharmacy-medcare/#${this.currentUrl}`;
            window.location.href = fullUrl;
          }
          else if(firstRoute == "claim"){
            const fullUrl = `${this.env.medcareUrl}/claimManagement/#${this.currentUrl}`;
            window.location.href = fullUrl;
          }
          else{
          const fullUrl = `${this.env.medcareUrl}/${firstRoute}/#${this.currentUrl}`;
          window.location.href = fullUrl;
          }
        }    
        else{
          this.snackBar.error(errorName, errorMessage);
          if (errorMessage.includes("chunk")) window.location.reload();
        }
      };
    } catch (ex) {
      console.log(ex);
    }
  }

   getEnvironmentFlag(route)  {
    return environment.Modules[route.toLowerCase() as keyof typeof environment.Modules];
  }

  ngOnInit(){
    this.router.events.subscribe((event:any) => {
      this.currentUrl = event.url;
      if (event instanceof RouteConfigLoadStart) {
        this.loadingRouteConfig = true;
        this.ngxService.start();
      } else if (event instanceof RouteConfigLoadEnd) {
        setTimeout(() => {
          this.ngxService.stop();
        }, 1000);
        this.loadingRouteConfig = false;
      }
    });
  }

  getSelectedLanguage() {
    let selectedLanguage = localStorage.getItem("lan");
    let browserLang: string = this.translate.getBrowserLang();
    return selectedLanguage ? selectedLanguage : browserLang;
  }
}
